import React from 'react';
import { withRouter } from '../../common/utils/NavigationWrapper';
import PageContainer from '../../common/components/Page/PageContainer';
import FleetsViewContainer from './components/FleetsView/FleetsViewContainer';
import FleetEditorContainer from './components/FleetEditor/FleetEditorContainer';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';
import './Fleets.css';

const Fleets = (props) => (
  <PageContainer pageName="fleets">
    <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.VIEW_FLEETS}>
      {props.params.id ? <FleetEditorContainer /> : <FleetsViewContainer />}
    </PermissionsCheck>
  </PageContainer>
);

export default withRouter(Fleets);
